import { render, staticRenderFns } from "./CommunityHeader.vue?vue&type=template&id=233da9ae"
import script from "./CommunityHeader.vue?vue&type=script&lang=js"
export * from "./CommunityHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports